import { modals } from './modals';

const initVideoModal = (modal) => (e) => modal.isOpen ? modal.resetContentToInitial() : modal.clearContent();

const initVideoModals = () => {
  const videoBlocks = Array.from(document.querySelectorAll('[data-video-block]'));

  videoBlocks.forEach((block) => {
    const modalEl = block.querySelector('[data-modal]');
    if (!modalEl) {
      return;
    }

    const modal = modals[modalEl.id];
    if (!modal) {
      return;
    }

    modal.el.addEventListener('changeModalOpen', initVideoModal(modal));
  });
};

export default initVideoModals;
